"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleLabRequisitionPayloadToFormDataHandler = scheduleLabRequisitionPayloadToFormDataHandler;
const utils_1 = require("../../utils");
function scheduleLabRequisitionPayloadToFormDataHandler(data) {
    let insuranceInformation;
    const insurancePolicyType = data.form.insuranceInformation.policyType;
    if (insurancePolicyType === "Medicare") {
        insuranceInformation = {
            policyType: "Medicare",
            mbi: data.form.insuranceInformation.mbi,
        };
    }
    else if (insurancePolicyType === "Managed Medicare") {
        insuranceInformation = {
            policyType: "Managed Medicare",
            policyNumber: data.form.insuranceInformation.policyNumber,
            policyProvider: data.form.insuranceInformation.policyProvider,
        };
    }
    else {
        throw new Error(`Panic: unsupported payment method: ${insurancePolicyType}`);
    }
    let specimenInformation;
    const requisitionType = data.form.specimenInformation.requisitionType;
    const collectionDate = (0, utils_1.dayjsParse)(data.form.specimenInformation.collectionDate).valueOf();
    if (requisitionType == "Standing Order") {
        specimenInformation = {
            requisitionType: "Standing Order",
            collectionDate,
            collectionTime: data.form.specimenInformation.collectionTime,
            collectionTimeZone: data.form.specimenInformation.collectionTimeZone,
            collectionDays: data.form.specimenInformation.collectionDays,
            collectionFrequency: data.form.specimenInformation.collectionFrequency,
            terminationDate: (0, utils_1.dayjsParse)(data.form.specimenInformation.terminationDate).valueOf(),
        };
    }
    else if (requisitionType === "Collected by Facility") {
        specimenInformation = {
            requisitionType: "Collected by Facility",
            collectionDate,
            collectionTime: data.form.specimenInformation.collectionTime,
            collectionTimeZone: data.form.specimenInformation.collectionTimeZone,
        };
    }
    else if (requisitionType === "Lab Collection Request") {
        specimenInformation = {
            requisitionType: "Lab Collection Request",
            collectionDate,
            collectionTime: data.form.specimenInformation.collectionTime,
            collectionTimeZone: data.form.specimenInformation.collectionTimeZone,
        };
    }
    else {
        throw new Error(`Panic: unsupported requisition type: ${requisitionType}`);
    }
    return {
        id: data.form.id,
        labInformation: {
            labId: data.form.labId,
        },
        providerInformation: {
            providerNPI: data.form.providerNPI,
        },
        comments: data.form.comments,
        tests: data.form.tests.map(t => ({
            labTest: JSON.stringify({
                loincCode: t.loincCode,
                specimenType: t.specimenType,
                panelType: t.panelType,
                specimenSource: t.specimenSource,
            }),
        })),
        diagnosis: data.form.diagnosis.map(d => ({
            icdCode: JSON.stringify({ label: d.name, value: d.code }),
        })),
        specimenInformation: specimenInformation,
        patientInformation: {
            id: data.form.patientInformation.id,
            firstName: data.form.patientInformation.firstName,
            lastName: data.form.patientInformation.lastName,
            gender: data.form.patientInformation.gender,
            roomNo: data.form.patientInformation.roomNo,
            dateOfBirth: (0, utils_1.dayjsParse)(data.form.patientInformation.dateOfBirth).valueOf(),
            addressOne: data.form.patientInformation.addressOne,
            addressTwo: data.form.patientInformation.addressTwo,
            city: data.form.patientInformation.city,
            state: data.form.patientInformation.state,
            zipCode: data.form.patientInformation.zipCode,
            countryCode: data.form.patientInformation.countryCode,
            phoneNumber: data.form.patientInformation.phoneNumber,
        },
        insuranceInformation: insuranceInformation,
    };
}
